export function cleanEmail(email: string) {
  const emailTrimmedAndLowerCase = email.trim().toLowerCase();

  if (!emailTrimmedAndLowerCase.includes("gmail")) {
    return emailTrimmedAndLowerCase;
  }

  // make sure is always gmail.com
  const [local] = emailTrimmedAndLowerCase.split("@");

  // Could return early here if domain is gmail.com... but same thing really

  return `${local}@gmail.com`;
}
